export { default } from './ResultsCount';
